import React from "react";
import { Button, Modal, Table } from "react-bootstrap";

function PDFViewModel(props) {
  
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="normal-modal legal-pdf-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {props?.show?.machinename}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="log-detail-code-main">
          {" "}
          <iframe
            src={props?.show?.contracturl}
            width="100%"
            // height=""
            title="PDF Preview"
          ></iframe>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default PDFViewModel;
